import React, { useEffect, useState } from 'react';
import './NoveltiesBanner.css';

const NoveltiesBanner = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    return (
      <section className="novelties-banner novelties-banner--mobile">
        <img
          src="/assets/new1.png"
          alt=""
          className="novelties-banner-drip"
          aria-hidden="true"
        />
        <div className="novelties-banner-text">Novelties</div>
      </section>
    );
  }

  // Desktop version (keep existing background logic)
  return (
    <section
      className="novelties-banner"
      style={{
        backgroundImage: `url(/assets/nov-bg.png)`,
      }}
    >
      <div className="novelties-banner-text">Novelties</div>
    </section>
  );
};

export default NoveltiesBanner;
